export const getThemeFonts = (fontFamily) => ({
    textFont: `${fontFamily ? `${fontFamily}, ` : ''}'Inter', sans-serif`,
    codeFont: 'monospace',
});
